import React from "react";
import { Navigate } from "react-router-dom";
import { buildContextPath, getDefaultModuleForLevel, isModuleAllowedForLevel } from "config/contextModules";
import { renderContextModule } from "config/contextModuleRegistry";
import { useLocationContext } from "context/LocationContext";
import useAuth from "hooks/useAuth";

function UnknownModuleState({ moduleSlug, level }) {
  return (
    <div className="main-content">
      <div className="card">
        <h2 className="text-xl font-semibold text-foreground mb-2">Module Not Available</h2>
        <p className="text-muted-foreground">
          The selected module could not be resolved for the current location.
        </p>
        {moduleSlug && (
          <p className="mt-2 text-xs text-muted-foreground">
            Module: <span className="font-mono">{moduleSlug}</span> · Level: {level}
          </p>
        )}
      </div>
    </div>
  );
}

export default function ContextModuleRenderer() {
  const { user } = useAuth();
  const {
    assessmentUsers,
    currentLocation,
    currentModuleSlug,
    isAssessmentUsersLoading,
    isOrgTreeLoading,
  } = useLocationContext();
  const level = currentLocation?.level || "national";

  if (
    isOrgTreeLoading
    || isAssessmentUsersLoading
    || currentLocation?.hasAccess === false
  ) {
    return (
      <div className="flex min-h-48 items-center justify-center text-sm text-muted-foreground">
        Loading location...
      </div>
    );
  }

  if (!currentModuleSlug) {
    return (
      <Navigate
        to={buildContextPath(
          currentLocation,
          getDefaultModuleForLevel(
            level,
            user,
            assessmentUsers,
            currentLocation,
          ),
        )}
        replace
      />
    );
  }

  if (!isModuleAllowedForLevel(
    currentModuleSlug,
    level,
    user,
    assessmentUsers,
    currentLocation,
  )) {
    return (
      <Navigate
        to={buildContextPath(
          currentLocation,
          getDefaultModuleForLevel(
            level,
            user,
            assessmentUsers,
            currentLocation,
          ),
        )}
        replace
      />
    );
  }

  const content = renderContextModule(currentModuleSlug, { level });

  if (content) {
    return content;
  }

  return <UnknownModuleState moduleSlug={currentModuleSlug} level={level} />;
}
